var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bk-full"},[_c('p',{staticClass:"hint-title",style:({
      color: _vm.isThemeWidget ? _vm.customStyle.active_text_color : '',
    })},[_vm._v(" Количество участников ")]),_c('el-input-number',{staticClass:"w-full",class:{
      'custom-style': _vm.isThemeWidget,
    },style:({
      background: _vm.isThemeWidget ? _vm.customStyle.background_cells_fields : '',
    }),attrs:{"value":_vm.value,"min":1,"max":_vm.maxCount},on:{"input":function($event){_vm.$emit('input', $event), _vm.emitData($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }